














































































import { Component, Prop, Vue } from "vue-property-decorator";
import AppVue from "@/AppVue.vue";

import { InputSelectCpt, InputDateRangeCpt, InputFieldCpt, InputSearchFieldCpt } from "@/core/components";
import { WorkshopFilterModel, WorkshopGridLookups, DateRangeModel, GridModel, GridFilter } from "@/core/models";

import { WorkshopService } from "@/core/services";

@Component({
  components: {
    InputSelectCpt,
    InputDateRangeCpt,
    InputFieldCpt,
    InputSearchFieldCpt,
  },
})
export default class WorkflowGridFiltersCpt extends AppVue {
  @Prop() filter: WorkshopFilterModel;
  @Prop() grid: GridModel<any, GridFilter>;

  dateRange = {} as DateRangeModel;

  lookups = {} as WorkshopGridLookups;
  loading = false;

  async created() {
    await this.initializeLookups();
    this.initializeDateRangeFilter();
  }

  private dateRangeChanged() {
    if (!this.dateRange || !this.dateRange.dateRange || this.dateRange.dateRange.length <= 1) {
      this.filter.startDate = "" as any;
      this.filter.endDate = "" as any;
    } else {
      this.filter.startDate = this.dateRange.dateRange[0];
      this.filter.endDate = this.dateRange.dateRange[1];
    }
    this.changed();
  }

  private changed() {
    this.$emit("filter-changed", this.filter);
  }
  private initializeDateRangeFilter() {
    this.dateRange = {
      dateRange: [this.filter.startDate, this.filter.endDate],
    };
  }

  private async initializeLookups() {
    this.loading = true;
    try {
      this.lookups = await WorkshopService.getWorkshopGridLookups();
      this.lookups.regions.unshift({
        id: 0,
        text: "All",
      });
      this.lookups.workshopStatus.unshift({
        id: 0,
        text: "All",
      });
      this.lookups.counties.unshift({
        id: 0,
        text: "All",
      });
    } finally {
      this.loading = false;
    }
  }
}
